export default function(fields) {
  return {
    currentPassword: fields && fields.currentPassword,
    newPassword: fields && fields.newPassword,
    userType: fields && fields.userType,
    orgId: fields && fields.orgId
  }
}

